export default {
  container: 'hidden md:flex h-[84px] w-[100%] px-[20px] justify-between items-center border-b border-[#CCDCE8]',
  title: 'font-interSemibold text-[24px] text-[#101828]',
  wrapper: 'flex items-center gap-[12px] cursor-pointer hover:opacity-80',
  text: 'font-inter text-[16px] text-[#101828]',
  hidden: 'hidden',
};
